import React, { useEffect } from 'react';
import { useAtom } from 'jotai/index';
import { useSearchParams } from 'react-router-dom';
import moment from 'moment/moment';
import 'moment/locale/hy-am';
import 'moment/locale/kk';
import styles from './css/index.module.scss';
import useWidget from '../../hooks/UseWidget';
import {
  widgetDataAtom,
  widgetParamsAtom,
  widgetScreenStateAtom,
  widgetSelectedLanguageAtom,
} from '../../atoms/widgetAtoms';
import WidgetHeader from './components/WidgetHeader';
import MyModal from '../../components/MyModal';
import widgetStates from './constants/widgetStates';
import WidgetSlotsState from './components/WidgetSlotsState';
import WidgetInputsState from './components/WidgetInputsState';
import WidgetSuccessState from './components/WidgetSuccessState';
import WT from './constants/widgetTranslations';
import WidgetFooter from "./components/WidgetFooter";

function Widget() {
  const {
    initWidgetData, getSlots, requestToCloseWidget,
  } = useWidget();
  const [searchParams] = useSearchParams();

  const [widgetData] = useAtom(widgetDataAtom);
  const [widgetParams] = useAtom(widgetParamsAtom);
  const [widgetScreenState] = useAtom(widgetScreenStateAtom);
  const [widgetSelectedLanguage] = useAtom(widgetSelectedLanguageAtom);

  useEffect(() => {
    initWidgetData();
  }, []);

  useEffect(() => {
    if (!widgetData?.id) return;

    const timer = setTimeout(() => {
      getSlots().then();
    }, 400);

    return () => clearTimeout(timer);
  }, [widgetParams, widgetData?.id, widgetSelectedLanguage]);

  useEffect(() => {
    if (widgetSelectedLanguage.code === 'am') {
      moment.locale('hy-am');
    } else if (widgetSelectedLanguage.code === 'kz') {
      moment.locale('kk');
    } else if (widgetSelectedLanguage.code === 'en') {
      moment.locale('en');
    } else {
      moment.locale('ru');
    }
  }, [widgetSelectedLanguage]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.action === 'close') {
        requestToCloseWidget();
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [requestToCloseWidget]);

  const onTelegramClick = () => {
    const message = 'lala';
    // window.open(`tg://msg_url?text=${message}`, '_blank');
    window.location.href = `tg://msg_url?text=${message}`;
  };

  const onWhatsappClick = () => {
    const message = 'lala';
    // window.open(`https://wa.me?text=${message}`, '_blank');
    window.location = `https://wa.me?text=${message}`;
  };

  return (
    <div className={styles.wrapper}>
      {/*      <button onClick={onTelegramClick}>telegram</button>
      <br />
      <br />
      <button onClick={onWhatsappClick}>wa</button>
      <br />
      <br />
      <a href="tg://msg_url?text=Hello" target="_blank" rel="noreferrer">Open in Telegram</a> */}
      <WidgetHeader requestToCloseWidget={requestToCloseWidget} />

      <div className={styles.container}>
        {widgetScreenState === widgetStates.slots
          ? <WidgetSlotsState />
          : widgetScreenState === widgetStates.inputs
            ? <WidgetInputsState />
            : widgetScreenState === widgetStates.success
              ? <WidgetSuccessState />
              : null}
        {widgetScreenState && <WidgetFooter screen={widgetScreenState} />}
      </div>

      <MyModal />
    </div>
  );
}

export default Widget;
